import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { departureDate, guestsInRoom } from '../actions/dive-operator-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
  itineraryPopupOpen,
  itineraryPopupData,
  resortInclusionsOpen,
  resortInclusionPopupData,
} from '../actions/main-actions'
import { currencyDirective, collapseItems, openToggler } from '../directives'
import { getLanguage, checkIsEditOrder, getTranslations } from 'utils'
import 'babel-polyfill'
import 'whatwg-fetch'

import HeroLightbox from '../components/liveaboard/HeroLightbox'
import ResortPricing from '../components/resort/ResortPricing'
import PriceConverter from '../components/helpers/PriceConverter'
import VirtualTourPopup from '../components/popups/VirtualTourPopup'
import BackSectionDeparture from '../components/resort/BackSectionDeparture'
import ErrorHandler from '../components/ErrorHandler'
import GroupTripPackages from '../components/group-trips/GroupTripPackages'
import OtherGroupTrips from '../components/group-trips/OtherGroupTrips'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import { createRoot } from 'react-dom/client'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

checkIsEditOrder()

let store = createStore(
  combineReducers({
    pageLoader,
    selectedCurrency,
    departureDate,
    guestsInRoom,
    itineraryPopupOpen,
    itineraryPopupData,
    resortInclusionsOpen,
    resortInclusionPopupData,
  }),
)

let language = getLanguage()
let messages = {}

window.operatorStore = store
window.store = store
configure(store)

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  renderElement('resort-pricing', ResortPricing, {
    ...window.shop,
    availablePackageKinds: window.availablePackageKinds,
    hasStudentCourses: window.hasStudentCourses,
    isFixedPackage: !window.shopIsDynamicPackages,
  })
  renderElement('hero-lightbox', HeroLightbox, {
    photos: window.photos,
    videos: window.videos,
  })
  renderElement('trip-pricing', GroupTripPackages, {
    mainPage: true,
    slug: window.shop.slug,
    groupTripId: window.shop.id,
    currency: window.shop.currency,
    tripInfo: {
      title: window.shop.title,
      duration: window.shop.duration,
      dateEnd: window.shop.dateEnd,
      dateStart: window.shop.dateStart,
      groupSizeMin: window.shop.groupSizeMin,
      groupSizeMax: window.shop.groupSizeMax,
      countryTitle: window.shop.countryTitle,
      operatorTypesName: window.shop.operatorTypesName,
      operatorTypes: window.shop.operatorTypes,
      organiserTitle: window.shop.organiserTitle,
    },
  })
  renderElement('other-diveoperators', OtherGroupTrips, window.shop)
  renderElement('back-section-departure', BackSectionDeparture)
  renderElement('virtual-tour-popup', VirtualTourPopup, {
    virtualTourLink: window.virtualTourLink,
  })
  renderElement('minimum-price', PriceConverter, {
    amount: +window.shop.minimumPrice,
    currency: window.shop.currency,
  })
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  openToggler()
  collapseItems()
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
